;
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { FaBookmark } from "react-icons/fa";
import { MdDesignServices } from "react-icons/md";
import TtkList from './TtkList';
const ArtistTTK = ({ data }) => {
    return (
        <div className="row">
            <div className="col-md-12">
                <div className='row mb-1'>
                    <div className='col-md-3'>
                        <p><WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since:</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                    </div>
                    <div className='col-md-3'>
                        <p><LocationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Area of Services :</b>&nbsp;<TtkList data={data?.areaOfWorking} /></p>
                    </div>
                    <div className='col-md-3'>
                        <p> <MdDesignServices size={20} sx={{ fontSize: 25 }} style={{ color: "black" }} />&nbsp;<b>Types of Artist :</b>&nbsp;<TtkList data={data?.choreographerStyle} /></p>
                    </div>
                    <div className='col-md-3'>
                        <p> <MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Starting Price :</b>&nbsp;&#8377;&nbsp;<span>{data?.price}</span></p>
                    </div>
                </div>
                <div className='row mb-1'>
                    <div className='col-md-3'>
                        <p ><FaBookmark sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Do You Provide Back Dancers? :</b>&nbsp;<span>{data?.backDancers}</span></p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ArtistTTK